export default __webpack_public_path__ + "static/media/happy-certificate.ac8ab759.jpg";